export default async function searchProducts(query) {
    if (!query || query.length < 2) {
        return [];
    }

    try {
        const res = await fetch(`/admin/autocomplete/products?name=${query}`);
        const json = await res.json();
        return json.data || [];
    } catch {
        return [];
    }
}
